import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, ts } from "@/lib/api";
import { Panel, Th, Td, field } from "@/components/ui-kit";

const ENT = { "": "Everything", item: "Item Master", partner: "Trading partners", sap_idoc: "SAP IDoc settings", delivery_point: "Delivery points", pricing: "Prices" };
const ACT = { added: "text-sky-300", changed: "text-amber-300", deleted: "text-rose-300" };

const Changes = ({ r }) => {
  const c = Object.entries(r.changes || {});
  if (!c.length) return <span className="text-slate-400">{r.detail}</span>;
  return (
    <div className="space-y-0.5">{c.slice(0, 8).map(([k, [a, b]]) => (
      <div key={k} className="font-mono text-xs"><span className="text-slate-500">{k}</span> <span className="text-slate-500 line-through">{a || "(blank)"}</span> → <span className="text-sky-300">{b || "(blank)"}</span></div>))}
      {c.length > 8 && <div className="text-xs text-slate-500">+{c.length - 8} more</div>}
      {r.detail && <div className="text-xs text-slate-400">{r.detail}</div>}
    </div>
  );
};

export default function ChangeLog() {
  const [rows, setRows] = useState(null);
  const [entity, setEntity] = useState("");
  const [q, setQ] = useState("");
  useEffect(() => {
    const t = setTimeout(() => api.get("/change-log", { params: { entity, q } }).then((r) => setRows(r.data)), 250);
    return () => clearTimeout(t);
  }, [entity, q]);
  return (
    <div className="space-y-6" data-testid="change-log-page">
      <div className="flex items-center gap-3"><History className="h-6 w-6 text-red-500" /><h1 className="text-4xl font-semibold tracking-tight sm:text-5xl">Change log</h1></div>
      <p className="max-w-3xl text-sm text-slate-400">Every addition, change and deletion to products, trading partners, SAP IDoc settings, delivery points and prices - who did it, when, and where (screen or imported PO).</p>
      <Panel title="Changes" testId="change-log-panel"
        action={<div className="flex flex-wrap justify-end gap-2">
          <select value={entity} onChange={(e) => setEntity(e.target.value)} className={`h-8 rounded-md border px-2 text-xs ${field}`} data-testid="change-log-entity">{Object.entries(ENT).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search code, user, PO…" className={`h-8 w-36 text-xs sm:w-56 ${field}`} data-testid="change-log-search" />
        </div>}>
        {rows === null ? <p className="px-5 py-4 text-xs text-slate-500">Loading…</p> : !rows.length ? <p className="px-5 py-4 text-xs text-slate-500" data-testid="change-log-empty">No changes recorded yet.</p> : (
          <div className="overflow-x-auto"><table className="w-full">
            <thead className="border-b border-slate-800"><tr><Th>When</Th><Th>Who</Th><Th>What</Th><Th>Code</Th><Th>Customer</Th><Th>Change</Th><Th>Where</Th></tr></thead>
            <tbody className="divide-y divide-slate-800/70">{rows.map((r) => (
              <tr key={r.id} data-testid={`change-log-row-${r.id}`}>
                <Td className="whitespace-nowrap font-mono text-xs">{ts(r.at)}</Td><Td className="text-sm">{r.user}</Td>
                <Td className="whitespace-nowrap text-sm">{ENT[r.entity] || r.entity} <span className={`text-xs font-semibold ${ACT[r.action] || ""}`}>{r.action}</span></Td>
                <Td className="font-mono text-xs">{r.key}</Td><Td className="font-mono text-xs">{r.partner || "-"}</Td>
                <Td><Changes r={r} /></Td><Td className="text-xs text-slate-400">{r.source}</Td>
              </tr>))}</tbody>
          </table></div>)}
      </Panel>
    </div>
  );
}
